import script from "./ScopePreviewStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopePreviewStep.vue?vue&type=script&setup=true&lang=js"

import "./ScopePreviewStep.vue?vue&type=style&index=0&id=4b2d1019&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b2d1019"]])

export default __exports__